import ErrorReport from './ErrorReport'
import About from './About'
import Methods from './Methods'
import OtherResources from './OtherResources'
import CreateAccount from './Accounts/CreateAccount'
import SendPasswordResetLink from './Accounts/SendPasswordResetLink'
import Feedback from './Feedback'
import SignIn from './Accounts/SignIn'
import LayerDescription from './LayerDescription'
import Disclaimer from './Disclaimer'
import ProjectSave from './Projects/Save'
import ProjectLoad from './Projects/Load'
import ProjectDelete from './Projects/Delete'
import Print from './Print'

export default {
    disclaimer: Disclaimer,
    about: About,
    methods: Methods,
    feedback: Feedback,
    error: ErrorReport,
    other: OtherResources,
    signIn: SignIn,
    createAccount: CreateAccount,
    sendPasswordResetLink: SendPasswordResetLink,
    layerDescription: LayerDescription,
    projectSave: ProjectSave,
    projectLoad: ProjectLoad,
    projectDelete: ProjectDelete,
    print: Print,
    '': null
}
